import { atom } from "jotai";

/**
 * Flips to `true` once `loadInitialCart` has finished its first pass, whatever
 * the outcome (backend cart, localStorage cart, or nothing).
 *
 * `cartAtom` starts empty, so anything that treats "empty cart" as a decision
 * point — notably the checkout layout, which kicks the customer back to the
 * storefront — cannot tell "the bag is empty" apart from "the bag has not been
 * read yet". On a full page load into a checkout step those two are the same
 * state for a few frames, and the customer got bounced home with a full bag.
 * Reactive on purpose: `_cartInitialized` in `use-cart` is a module flag and
 * never re-renders anyone.
 */
const cartHydratedAtom = atom<boolean>(false);

export default cartHydratedAtom;
